let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2ip6N")).then(() => parcelRequire('bH33C'));